function elemsFlatten(blocks) {
  const flatten = (arr) => {
    return arr.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
  };

  let blocksItens = [];

  blocks.map((it) => {
    if (it.elements && it.elements.length > 0) {
      blocksItens.push(it.elements);
    }

    return it;
  });

  return flatten(blocksItens);
}

export function filterFlatten(api, setEnrollmentBlocks) {
  if (api && api.node && api.node.blocks && api.node.blocks.length > 0) {
    const elents = elemsFlatten(api.node.blocks);
    setEnrollmentBlocks(elents);
  } else {
    setEnrollmentBlocks([]);
  }
}
